import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from '@headlessui/react'
import { MagnifyingGlassIcon, CalendarIcon } from "@heroicons/react/24/outline";
import ServerTable from "../../../components/atoms/tables/serverTable";
import { debounce } from "lodash";
import { useStore } from "../../../store";
import InlineLoader from "../../../components/atoms/inlineLoader";
import Axios from "../../../AxiosConfig";
import swal from 'sweetalert';
const Holidays = () => {
    const [open, setOpen] = useState(false)
    const [query, setQuery] = useState("");
    const [_date, setDate] = useState("");
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [serverTableKey, setServerTableKey] = useState(0);
    const { layoutStore } = useStore();
    const cancelButtonRef = useRef(null)
    const columns = [
        {
            name: "Holiday Name",
            selector: "name",
            sortable: true,
            sortField: "name",
        },
        {
            name: "Date",
            sortable: true,
            sortField: "date",
            selector: "date",
            cell: (row) => {
                return (
                    <div>
                        {new Date(row.date).toLocaleDateString()}
                    </div>
                )
            }
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex justify-end">
                    <button
                        className="text-red-600 hover:text-red-900 ml-1 font-semibold rounded-full hover:bg-red-500 hover:text-white p-1"
                        // popup confirm
                        onClick={() => {
                            swal({
                                text: "Are you sure you want to delete this Holiday?",
                                icon: "warning",
                                buttons: true,
                                dangerMode: true,
                            })
                            .then((willDelete) => {
                                if (willDelete) {
                                    Axios.post(`/company/holiday/delete`, {
                                        date: row.date
                                    }).then((res) => {
                                        if (res.data.success) {
                                            layoutStore.showToaster(`Holiday Deleted`, "success");
                                            setServerTableKey(serverTableKey + 1);
                                        }
                                        else {
                                            layoutStore.showToaster(res.data.error, "error");
                                        }
                                    })
                                }
                            });

                            // let confirm = window.confirm(`Are you sure you want to delete this Holiday ?`);
                            // if (confirm) {
                            //     Axios.post(`/company/holiday/delete`, {
                            //         date: row.date
                            //     }).then((res) => {
                            //         if (res.data.success) {
                            //             layoutStore.showToaster(`Holiday Deleted`, "success");
                            //             setServerTableKey(serverTableKey + 1);
                            //         }
                            //         else {
                            //             layoutStore.showToaster(res.data.error, "error");
                            //         }
                            //     })
                            // }
                        }}
                    >
                        Delete
                    </button>
                </div>
            )
        }
    ]
    useEffect(() => {
        const selectedFilters = {};
        if (query.length > 0) {
            selectedFilters["query"] = query;
        }
        if (_date) {
            selectedFilters["date"] = _date;
        }
        debounce(() => {
            setFilters({ ...selectedFilters });
        }, 500)();

    }, [query, _date]);
    return (
        <>
            <div>
                <div className="text-right">
                    <div className="my-1 flex rounded-md shadow-sm">
                        <div className="relative flex flex-grow items-stretch focus-within:z-10">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </div>
                            <input
                                type="search"
                                name="search"
                                onChange={(e) => setQuery(e.target.value)}
                                className="block w-full rounded-l-md border-gray-300 hover:border-blue-500 pl-10 mr-px focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                placeholder="Search..."
                            />
                        </div>
                        <div className="relative flex flex-grow mx-px items-stretch focus-within:z-10">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <CalendarIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </div>
                            <input
                                type="date"
                                name="date"
                                onChange={(e) => setDate(e.target.value)}
                                className="block w-full border-gray-300 hover:border-blue-500 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                        </div>
                        <span className="isolate inline-flex rounded-md shadow-sm">
                            <button
                                type="button"
                                className="inline-flex items-center rounded-r-md ml-px border border-transparent bg-blue-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                onClick={() => setOpen(true)}

                            >
                                Add Holiday
                            </button>
                        </span>
                    </div>
                </div>
                <div>
                    <ServerTable
                        key={JSON.stringify(filters) + serverTableKey.toString()}
                        apiURL={`/company/holiday/search`}
                        columns={columns}
                        filters={filters}
                    />
                </div>
            </div>

            {/* Adding Modal */}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            let data = new FormData(e.target);
                                            setLoading(true);
                                            Axios.post(`/company/holiday/create`, {
                                                "name": data.get('name'),
                                                "date": data.get('date'),
                                            }).then((res) => {
                                                if (res.data.success) {
                                                    layoutStore.showToaster(`Holiday Added`, "success");
                                                    setServerTableKey(serverTableKey + 1);
                                                }
                                                else {
                                                    layoutStore.showToaster(res.data.error, "error");
                                                }
                                                setLoading(false);
                                                setOpen(false);
                                            });
                                        }}

                                    >
                                        <div>
                                            <div className="mt-3 text-center sm:mt-5">
                                                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                                    Add Holiday
                                                </Dialog.Title>
                                                <div className="mt-2 text-left">
                                                    <div>
                                                        <div className="mt-1">
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                                placeholder={`Holiday Name`}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-2 text-left">
                                                    <div>
                                                        <div className="mt-1">
                                                            <input
                                                                type="date"
                                                                name="date"
                                                                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                                required
                                                                min={new Date().toISOString().split('T')[0]}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                            <button
                                                type="submit"
                                                className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                            >
                                                {loading ? <>Adding <InlineLoader /></> : `Add Holiday`}
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                                onClick={() => setOpen(false)}
                                                ref={cancelButtonRef}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    )
}
export default Holidays